// extracted by mini-css-extract-plugin
export default {"spine-menu":"SpineMenuCsb_spine-menu__UEvED"};